/* eslint-disable import/first */
if (process.env.NODE_ENV) {
  // Must be the first import
  import('preact/debug');
} else {
  // Or if you just want the devtools bridge (~240B) without other
  // debug code (useful for production sites)
  import('preact/devtools');
}

import './main.css';
import 'utils/storefront/swym-custom.js';
import 'utils/storefront/abra-popup.js';
import 'utils/accordion.js';
import Layout from 'utils/layout';
import Video from 'utils/video';
import getBundleValue from 'utils/storefront/get-bundle-value';


// Not sure if this is the best approach here
// const addClassToBody = () => {
//   document.querySelector('body').classList.remove('opacity-0');
// };
// window.addEventListener('load', addClassToBody);

(() => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = new Layout();
  const moduleList = {};

  if (window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const { sectionId } = e.detail;
      const el = e.target.querySelector('[data-section]');
      const { m, data, videos } = moduleList[sectionId];
      m.default(el, { ...data, layout, videos });
    });
  }

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
      .then((m) => {
        const module = m.default;
        const modules = [...sections].filter(
          (section) => section.dataset.section === name,
        );
        modules.forEach((element) => {
          const { sectionId } = element.dataset;
          const dataEl = element.querySelector('[data-section-data]');
          const data = dataEl ? JSON.parse(dataEl.textContent) : {};
          const videoEls = element.querySelectorAll('[data-component="video"]');
          const videos =
            videoEls &&
            [...videoEls].map(
              (videoEl) => new Video({ element, video: videoEl, layout }),
            );
          moduleList[sectionId] = {
            m,
            data,
            videos,
          };
          module(element, { ...data, layout, videos });
        });
      })
      .catch(console.error);
  });

  window.getBundleValue = getBundleValue;
})();
